import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Fuel, Repeat, Receipt } from 'lucide-react';
const stats = [{
  icon: <Fuel className="w-6 h-6" data-id="element-49" />,
  value: '2 in 3',
  label: 'American drivers already belong to a fuel loyalty program.',
  source: 'YouGov, 2025'
}, {
  icon: <Repeat className="w-6 h-6" data-id="element-50" />,
  value: '85%',
  label: 'Monthly member retention at top convenience-store programs.',
  source: 'NACS'
}, {
  icon: <Receipt className="w-6 h-6" data-id="element-51" />,
  value: '50–70%',
  label: 'Of station sales come from loyalty members.',
  source: 'Comarch'
}];
export function Slide02GasLoyalty() {
  const container = {
    hidden: {
      opacity: 0
    },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
        delayChildren: 0.2
      }
    }
  };
  const item = {
    hidden: {
      opacity: 0,
      y: 30
    },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        type: 'spring',
        stiffness: 200,
        damping: 22
      }
    }
  };
  return <div className="w-full min-h-full flex flex-col justify-center p-[clamp(2rem,6vw,6rem)]" data-id="element-52">
      <div className="max-w-6xl mx-auto w-full" data-id="element-53">
        <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="text-center mb-[clamp(2rem,4vw,3.5rem)]" data-id="element-54">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-surface border border-surface-hover text-accent text-sm font-bold tracking-wide uppercase mb-5" data-id="element-55">
            Why This Works
          </div>
          <h2 className="text-[clamp(2.5rem,5vw,4.5rem)] font-bold leading-tight" data-id="element-56">
            Gas Loyalty is <span className="text-accent text-glow" data-id="element-57">Real</span>
          </h2>
          <p className="text-[clamp(1.125rem,2vw,1.5rem)] text-muted max-w-2xl mx-auto mt-4 text-balance" data-id="element-58">
            The behavior already exists. The opportunity is making yours the
            program they choose.
          </p>
        </motion.div>

        <motion.div variants={container} initial="hidden" animate="show" className="flex md:grid md:grid-cols-3 gap-4 md:gap-6 overflow-x-auto snap-x snap-mandatory hide-scrollbar pb-2 md:pb-0" data-id="element-59">
          {stats.map(stat => <motion.div key={stat.source} variants={item} className="min-w-[100%] md:min-w-0 snap-center p-6 md:p-8 rounded-3xl bg-surface border border-surface-hover flex flex-col" data-id="element-60">
              <div className="w-12 h-12 rounded-xl bg-background flex items-center justify-center text-accent mb-4 md:mb-6 shrink-0" data-id="element-61">
                {stat.icon}
              </div>
              <div className="text-[clamp(2.5rem,4vw,3.75rem)] font-black text-white tracking-tighter mb-2 md:mb-3 leading-none" data-id="element-62">
                {stat.value}
              </div>
              <p className="text-sm md:text-base text-muted leading-relaxed flex-1" data-id="element-63">
                {stat.label}
              </p>
              <div className="mt-4 md:mt-5 pt-3 md:pt-4 border-t border-surface-hover text-[10px] md:text-xs font-bold tracking-widest uppercase text-muted/60" data-id="element-64">
                {stat.source}
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </div>;
}